import { useEffect, useRef, useState } from "react";
import { ServiceJ1SSnap } from "./ServiceJ1SSnap";
import { ServiceJ1SNormal } from "./ServiceJ1SNormal";

import { isApplySnap } from "@/utils";

export function ComponentServiceJetOneSuites({ pageContent = {} }) {
	const [applySnap, setApplySnap] = useState(false);

	useEffect(() => {
		setApplySnap(isApplySnap());
		function orientationChanged() {
			const timeout = 120;
			return new window.Promise(function (resolve) {
				const go = (i, height0) => {
					window.innerHeight != height0 || i >= timeout
						? resolve()
						: window.requestAnimationFrame(() => go(i + 1, height0));
				};
				go(0, window.innerHeight);
			});
		}
		window.addEventListener("orientationchange", function () {
			orientationChanged().then(function () {
				// Profit
				setApplySnap(isApplySnap());
			});
		});
		return () => {
			window.removeEventListener("orientationchange", function () {
				orientationChanged().then(function () {
					// Profit
					setApplySnap(isApplySnap());
				});
			});
		};
	}, []);

	return (
		<>
			{applySnap ? (
				<>
					<ServiceJ1SSnap pageContent={pageContent} />
				</>
			) : (
				<ServiceJ1SNormal pageContent={pageContent} />
			)}
		</>
	);
}
